/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type BackordersTable_backorderEdges$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PaginatedBackordersContainer_backorders$ref: FragmentReference;
declare export opaque type PaginatedBackordersContainer_backorders$fragmentType: PaginatedBackordersContainer_backorders$ref;
export type PaginatedBackordersContainer_backorders = {|
  +backorders: {|
    +edges: ?$ReadOnlyArray<?{|
      +cursor: string,
      +$fragmentRefs: BackordersTable_backorderEdges$ref,
    |}>
  |},
  +$refType: PaginatedBackordersContainer_backorders$ref,
|};
export type PaginatedBackordersContainer_backorders$data = PaginatedBackordersContainer_backorders;
export type PaginatedBackordersContainer_backorders$key = {
  +$data?: PaginatedBackordersContainer_backorders$data,
  +$fragmentRefs: PaginatedBackordersContainer_backorders$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PaginatedBackordersContainer_backorders",
  "type": "Query",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "backorders"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": 30
    },
    {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "search",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "sortBy",
      "type": "BackorderSort",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "statuses",
      "type": "[BackorderStatus!]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "customerIds",
      "type": "[ID!]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "orderIds",
      "type": "[ID!]",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "backorders",
      "name": "__PaginatedBackordersContainer_backorders_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "BackorderConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "BackorderEdge",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Backorder",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "BackordersTable_backorderEdges",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1cf356e59f2ae22e846aa4ee403142d8';
module.exports = node;
